const itemListSchema = ({
  name,
  description,
  url,
  items = [],
  itemListOrder = "https://schema.org/ItemListUnordered",
}) => ({
  "@context": "https://schema.org",
  "@type": "ItemList",
  "@id": `${url}#itemlist`,
  name,
  description,
  url,
  itemListOrder,
  numberOfItems: items.length,

  itemListElement: items.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item.name,
    url: item.url,
    ...(item.image && {
      image: item.image,
    }),
  })),
});

export default itemListSchema;